export default "__VITE_ASSET__C5a7LbYN__"